import React from 'react';

const colorMap = {
  orange: { bg: 'bg-orange-500', light: 'bg-orange-50', text: 'text-orange-600' },
  violet: { bg: 'bg-violet-500', light: 'bg-violet-50', text: 'text-violet-600' },
  emerald: { bg: 'bg-emerald-500', light: 'bg-emerald-50', text: 'text-emerald-600' },
  blue: { bg: 'bg-blue-500', light: 'bg-blue-50', text: 'text-blue-600' },
};

export default function StatCard({ title, value, subtitle, icon, trend, colorKey }) {
  const c = colorMap[colorKey] || colorMap.orange;
  return (
    <div
      className={`rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm transition hover:shadow-md ${c.light}`}
    >
      <div className="flex items-start justify-between">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium uppercase tracking-wide text-slate-500">{title}</p>
          <p className="mt-1 text-2xl font-bold tabular-nums text-slate-900">{value}</p>
          {subtitle != null && subtitle !== '' && (
            <p className="mt-0.5 text-sm text-slate-500">{subtitle}</p>
          )}
          {trend != null && <p className={`mt-1 text-xs font-medium ${c.text}`}>{trend}</p>}
        </div>
        <div
          className={`ml-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-white ${c.bg}`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
